export { PaymentFieldType } from './interface/form.interface.js';
export { HostedFieldAction } from './interface/messaging.interface.js';
export { FeeType, MethodType, RedirectMethod, RedirectType, TransactionStatus } from './interface/method.interface.js';
export { createFormHTML } from './util/form-html.js';
export { isFieldMessageEvent } from './util/messaging.js';
export { multiIntegration } from './multi-integration/multi-integration.js';

const createIntegration = (integration) => {
    return integration;
};

export { createIntegration };
